<!--
 * @Author: wxy
 * @Date: 2022-09-26 10:13:51
 * @LastEditTime: 2022-09-26 10:14:02
 * @Description: 已发起工单-流转记录
-->
<template>
  <div>流转记录</div>
</template>

<script>
export default {};
</script>

<style>

</style>